"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CompletedPartList_1 = require("./_CompletedPartList");
exports._CompletedMultipartUpload = {
    type: "structure",
    required: [],
    members: {
        Parts: {
            shape: _CompletedPartList_1._CompletedPartList,
            locationName: "Part"
        }
    }
};
//# sourceMappingURL=_CompletedMultipartUpload.js.map